<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" >
      <TabPane name="1" label="门锁设备列表" v-if="p('smartlock/smartLockList')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="门锁密码记录" v-if="p('smartlock/getPwdLogList')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="智能水电表设备" v-if="p('basics/all')">
        <c3></c3>
      </TabPane>
      <TabPane name="4" label="智能水电表抄表" v-if="p('waterwatt/read/list')">
        <c4></c4>
      </TabPane>
      <TabPane name="5" label="门禁设备" v-if="p('elevDevice/queryDeviceList')">
        <c5></c5>
      </TabPane>
      <TabPane name="6" label="门禁IC卡管理" v-if="p('elevIcCard/getIcCardList')">
        <c6></c6>
      </TabPane>
      <TabPane name="7" label="门禁日志管理" v-if="p('elevCallBack/getCallBackList')">
        <c7></c7>
      </TabPane>
      <TabPane name="8" label="智能工单管理" v-if="p('increase/getOrderList')">
        <c8></c8>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/passwordLock/getPassword/index'
  import C2 from '@/views/passwordLock/passwordRecord/index'
  import C3 from '@/views/smartPower/meterRecharge/index'
  import C4 from '@/views/smartPower/meterReading/index'
  import C5 from '@/views/ladderControl/device/index'
  import C6 from '@/views/ladderControl/icmanger/index'
  import C7 from '@/views/ladderControl/logs/index'
  import C8 from '@/views/smartWorkOrder/index'
  import {mixin} from "../../mixin";


  export default {
    name:'intelligent',
    mixins:[mixin],
    components:{
      C1,
      C2,
      C3,
      C4,
      C5,
      C6,
      C7,
      C8,
    }        ,
    data(){
      return {
        current:'1'
      }
    }

  }
</script>

<style scoped>

</style>
